export default __webpack_public_path__ + "static/media/bq.45167afb.svg";